var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("main", {
    staticClass: "preview"
  }, [_c("div", {
    staticClass: "m-frame"
  }, [_c("iframe", {
    ref: "frame",
    attrs: {
      src: _vm.url,
      frameborder: "0"
    }
  })])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };